module.exports = __webpack_public_path__ + "assets/img/wechat_logo.b4ae3496.png";